import DownloadIndex from '@/components/DownloadIndex.vue'
import HomeIndex from '@/components/HomeIndex.vue'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        component: HomeIndex,
        meta: { title: '生活记录' }
    },
    {
        path: '/download',
        component: DownloadIndex,
        meta: { title: '下载' }
    }
]

const router = createRouter({
    history: createWebHistory(), // 使用 HTML5 history 模式
    routes
})

router.afterEach((to)=>{
    if (to.meta && to.meta.title) {
        document.title = to.meta.title
    }
})

export default router